import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import LocationData from "./LocationModel/LocationData"

export default function LocationCreateObservable(data: LocationData): Observable<string> {
  const requestBody: string = JSON.stringify(data)
  return ObservableFromFetch<string>("FFOrderClientFileMaintenance/CreateLocationInformation", requestBody)
}
